var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      !_vm.isShowC
        ? _c("div", {
            staticClass: "editorShowArea ql-editor",
            domProps: { innerHTML: _vm._s(_vm.currentValue.questionContent) },
            on: {
              click: function($event) {
                return _vm.editor_toggle_questionContent()
              }
            }
          })
        : _c("v-editor", {
            model: {
              value: _vm.currentValue.questionContent,
              callback: function($$v) {
                _vm.$set(_vm.currentValue, "questionContent", $$v)
              },
              expression: "currentValue.questionContent"
            }
          }),
      _vm._v(" "),
      _c("v-addFile", {
        attrs: { isUploading: _vm.isUploading },
        on: { changeUploadStatus: _vm.changeUploadStatus },
        model: {
          value: _vm.currentValue.attachmentList,
          callback: function($$v) {
            _vm.$set(_vm.currentValue, "attachmentList", $$v)
          },
          expression: "currentValue.attachmentList"
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h1", [_c("strong", [_vm._v("*")]), _vm._v("题干\n    ")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7cec512c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7cec512c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/course/components/addTestPracticalTest.vue
// module id = null
// module chunks = 